import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** 採購金額顯示：保留數量與單價各兩位小數相乘後的最多四位小數。 */
export function formatNT(value: number): string {
  return `NT$${value.toLocaleString("zh-TW", { maximumFractionDigits: 4 })}`
}
